import { Box, Typography, useTheme } from "@mui/material";
import { Check } from "@mui/icons-material";
import { tokens } from "../../../theme";
import SectionCard from "./SectionCard";
import DetailRow from "./DetailRow";
import { useCopyFeedback } from "./useCopyFeedback";
import { sectionCardStyles, detailRowStyles } from "./styles";

const REPO_PORT = 5432;

// A freshly-created env may not have repository_info yet — the card still
// renders (with a "not provisioned" line) rather than being omitted, so its
// presence in the drawer is predictable.
const RepositoryConnectionCard = ({ row }) => {
  const theme = useTheme();
  const colors = tokens(theme.paletteId);
  const { state: copyState, copy } = useCopyFeedback();

  const repo = row?.meta?.repository_info;
  const provisioned = Boolean(
    repo?.schema_repo_tailscale_ip || repo?.schema_name_tessell
  );

  const buttonLabel =
    copyState === "copied"
      ? "Copied"
      : copyState === "error"
      ? "Couldn't copy"
      : "Copy as env vars";
  const buttonColor =
    copyState === "copied"
      ? colors.green[400]
      : copyState === "error"
      ? colors.red[500]
      : undefined;

  return (
    <SectionCard
      title="Repository connection"
      action={
        <Box
          component="button"
          type="button"
          sx={{
            ...sectionCardStyles.headAction(colors),
            ...(buttonColor && {
              color: buttonColor,
              borderColor: buttonColor,
            }),
          }}
          disabled={!provisioned}
          title={
            provisioned ? undefined : "Repository details not available yet"
          }
          onClick={() => copy(row?.repoConfig)}
        >
          {copyState === "copied" && (
            <Check sx={{ fontSize: "13px", mr: "4px" }} />
          )}
          {buttonLabel}
        </Box>
      }
    >
      {provisioned ? (
        <>
          <DetailRow
            label="Host"
            value={
              repo?.schema_repo_tailscale_ip
                ? `${repo.schema_repo_tailscale_ip}:${REPO_PORT}`
                : null
            }
            mono
            copyable
          />
          <DetailRow
            label="Database"
            value={repo?.schema_name_tessell}
            mono
            copyable
          />
          <DetailRow
            label="Username"
            value={repo?.schema_username}
            mono
            copyable
          />
          <DetailRow
            label="Password"
            value={repo?.schema_password}
            mono
            masked
          />
          <DetailRow
            label="Repo host"
            value={repo?.schema_repo_hostname}
            mono
            copyable
          />
        </>
      ) : (
        <Typography
          sx={detailRowStyles.subLine(colors)}
          component="div"
          py="10px"
        >
          Not provisioned yet
        </Typography>
      )}
    </SectionCard>
  );
};

export default RepositoryConnectionCard;
